module.exports = __webpack_public_path__ + "img/download_icon.e7ffe94c.svg";